import React from "react";
import { Redirect, Route } from "react-router-dom";
import { AUTH,PUBLIC } from "../../config/navigation";
import { getToken } from "../../utils";
 
const ProtectedRoute = (props) => {
  const { component: Component, url, ...rest } = props;
  const token = getToken();
   
  const checkAuth = () =>{
    if(token)
      {
        return true;
      }

      if(window.location.pathname===PUBLIC.PAYMENT_CANCELED 
        || window.location.pathname===PUBLIC.PAYMENT_SUCCEEDED){
          return true;
      }
      return false;
  }

  return (
    <Route
      {...rest}
      render={() => (checkAuth()
        ? (<Component {...props} />)
        : (
          <Redirect to={{
            pathname: AUTH.SIGNIN,
            state: { from: props.location },
          }}
          />
        ))}
    />
  );
};

export default ProtectedRoute;
